const heIL= {
    login: {
      title: 'כניסה',
      sign_in_btn: 'כניסה'
    },
    bar: {
        logout: 'יציאה',
        languages: 'שפות',
        settings: 'כניסה להגדרות'
    },
    language: {
      name: 'עברית (ישראל)',
    },
    attributePage: {
        title: 'שינויים בתכונות',
        viewChanges: 'צפייה בשינויים',
        dateTime: 'תאריך',
        notificationType: 'סוג ההודעה',
        notificationValue: 'ערך ההתראה',
        oldValue: 'ערך ישן',
        newValue: 'ערך חדש',
        accept: 'הסכם',
        reject: 'דחה',
    },
    Home: 'דף הבית',
    load: 'מבצע טעינה ראשונית...',
    Requested: "נדרש",
    Viewed: "נצפה",
    Executing: "מבצע",
    Completed: "הושלם",
    Expired: "פג תוקף",
    Cancelled: "בוטל",
    Error: "שגיאה",
    Rejected: "נדחה",
    error: 'משהו השתבש; נסה שוב מאוחר יותר.',
    displayname: 'שם תצוגה',
    givenname: 'שם פרטי',
    surname: 'שם משפחה',
    email: 'דוא"ל',
    mail: 'דוא"ל',
    name: 'שם פרטי',
    firstname: 'שם פרטי',
    lastname: 'שם משפחה',
    footer_copyright: 'כל הזכויות שמורות.'
  };
  
  export default heIL;
  